
import { Component, Vue } from 'vue-property-decorator';

import FormModule from '@/store/modules/form';
import { getGenderSelectorItems, getStateSelectorItems } from '@/utils/global.util';

@Component({})
export default class SweepstakesForm extends Vue {
  formStores: FormStore[];
  formModel: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    city: string;
    state: string;
    zip: number | null;
    store: string;
    gender: string;
    birthDate: Date | null;
    hasAcceptedEmailNotifications: boolean;
    hasAcceptedRules: boolean;
    hasAcceptedTicketKing: boolean;
    hasAcceptedESPNMilwaukee: boolean;
    hasAcceptedUWBadgers: boolean;
    hasAcceptedCousinsUpdate: boolean;
    hasAcceptedLammi: boolean;
    hasAcceptedSummerfest: boolean;
    optionsSelected: string | string[];
  };

  sweepstakesOptionArray: string[];
  sweepstakesOptionsPolling: any;
  isBadger: boolean;
  isGameday: boolean;
  isLammi: boolean;
  hasSummerfest: boolean;
  data() {
    return {
      formStores: null,
      formModel: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        zip: null,
        store: '',
        gender: '',
        birthDate: null,
        hasAcceptedEmailNotifications: true,
        hasAcceptedRules: false,
        hasAcceptedUWBadgers: false,
        hasAcceptedCousinsUpdate: false,
        optionsSelected: null,
      },
      sweepstakesOptionArray: [],
      sweepstakesOptionsPolling: null,
      isBadger: false,
      isGameday: false,
      isLammi: false,
      hasSummerfest: false
    }
  }

  async mounted() {
    const stores = await FormModule.getFormStores();
    this.formStores = stores;
    const stringBadger = 'BADGER';
    const stringGiveAway = 'GAMEDAY';
    const stringLammi = 'SOFTBALL';
    const stringSummerfest = 'GIG';
    const currentUrl = window.location.href.toUpperCase();

    if (currentUrl.includes(stringBadger)) {
      this.isBadger = true;
      this.isGameday = false;
      this.isLammi = false;
      this.hasSummerfest = false;
    }
    if (currentUrl.includes(stringGiveAway)) {
      this.isBadger = false;
      this.isGameday = true;
      this.isLammi = false;
      this.hasSummerfest = false;
    }
    if (currentUrl.includes(stringLammi)) {
      this.isBadger = false;
      this.isGameday = false;
      this.isLammi = true;
      this.hasSummerfest = false;
    }
    if (currentUrl.includes(stringSummerfest)) {
      this.isBadger = false;
      this.isGameday = false;
      this.isLammi = false;
      this.hasSummerfest = true;
    }

    this.sweepstakesOptionsPolling = setTimeout(async () => {
      const sweepstakesOptions = window?.__INITIAL_STATE__?.sweepstakesOptions;
      if (sweepstakesOptions) {
        clearInterval(this.sweepstakesOptionsPolling);
        const results: string[] = [];
        sweepstakesOptions.split(',').forEach((value) => {
          results.push(value.trim());
        });
        this.sweepstakesOptionArray = results;
      }
    }, 500);
  }

  beforeDestroy() {
    if (this.sweepstakesOptionsPolling) {
      clearTimeout(this.sweepstakesOptionsPolling);
    }
  }

  get redirectUrl() {
    return window?.__INITIAL_STATE__?.thankYouUrl;
  }

  get states() {
    return getStateSelectorItems();
  }

  get genders() {
    return getGenderSelectorItems();
  }

  get stores() {
    const stores = this.formStores;
    const results: SelectorItem[] = [];

    if (!stores) {
      return;
    }

    results.push({
      value: '',
      id: '',
      label: ''
    });

    stores.forEach((formStore) => {
      results.push({
        value: formStore.storeNumber,
        id: formStore.storeNumber,
        label: formStore.name
      });
    });

    return results;
  }

  async submitHandler(formModel) {
    if ((this.formModel.optionsSelected == null || this.formModel.optionsSelected.length <= 0) && this.sweepstakesOptionArray.length > 0) {
      this.$toasted.error('Please select at least one of the options');
    } else {
      const loader = this.$loading.show();
      try {
        await this.$recaptchaLoaded()
        const token = await this.$recaptcha('sweepstakes');

        const { sweepstakesSlug } = this.$route.params;
        await FormModule.submitSweepstakes({ ...formModel, recaptchaToken: token, slug: sweepstakesSlug } as SweepstakesRequest)
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl
        } else {
          this.$toasted.success('Your submission has been received!');
          this.formModel = {
            ...formModel,
            hasAcceptedEmailNotifications: true,
            hasAcceptedRules: false,
            selectedOptions: null
          };
        }
      } catch (err) {
        this.$log.error(err);
        this.$toasted.error(err.data);
      } finally {
        loader.hide();
      }
    }
  }
}

